// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fdc63880","296":"51c06f66","453":"e4641a1e","622":"009e3bc0","717":"173be442"}[chunkId] + ".chunk.js";
};